import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { AFFILIATE_FORM, ANIM, COLORS, MOBILE } from '@/nova/theme/tokens';

/* The game picker: a search over the tenant-0 game catalogue, a paginated thumbnail grid with multi-select, and a
   confirm footer. Colours/timings come only from theme tokens. */

/* Sticky because the body scrolls as one (the grid has no scroll of its own, so "Load more" can sit at
   the END of the list instead of pinned over the tiles): without this the search would scroll out of reach. */
export const Toolbar = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${AFFILIATE_FORM.surface};
  padding: 2px 0 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const Search = styled.input`
  flex: 1 1 180px;
  min-width: 140px;
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceInset};
  color: ${COLORS.text};
  font-size: 13px;

  &::placeholder {
    color: ${COLORS.textFaint};
  }
  &:focus {
    outline: none;
    border-color: ${COLORS.hoverBorderLit};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  padding: 2px;

  ${MOBILE} {
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  }
`;

export const GameCard = styled.button<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  text-align: left;
  transition: opacity ${ANIM.INTERACT_MS}ms ${ANIM.EASE};
`;

export const Thumb = styled.div<{ $selected: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  overflow: hidden;
  background: ${COLORS.surfaceInset};
  border: 2px solid ${({ $selected }) => ($selected ? COLORS.ctaSolid : COLORS.hairline)};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};
`;

export const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const Check = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: ${COLORS.ctaSolid};
  color: ${COLORS.ctaSolidText};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GameName = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 12px;
  color: ${COLORS.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 2px;
`;

export const Note = styled(Text).attrs({ tag: 'paragraph' as const })`
  font-size: 13px;
  color: ${COLORS.textFaint};
  padding: 20px 0;
  text-align: center;
`;

export const LoadMoreRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0 2px;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const SelCount = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 8px;
`;
